module.exports = __webpack_public_path__ + "img/figamein.2ff63e99.png";